(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Shared registration: safe when both gallery snippets are loaded.
  if (!customElements.get('scheduled-promo-badge')) {
    customElements.define('scheduled-promo-badge', class extends HTMLElement {
      static get observedAttributes() { return ['data-start', 'data-end']; }

      connectedCallback() {
        this.refresh = this.refresh || this.updateVisibility.bind(this);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
        this.updateVisibility();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      attributeChangedCallback() {
        if (this.isConnected) this.updateVisibility();
      }

      updateVisibility() {
        clearTimeout(this.timer);
        const startValue = this.getAttribute('data-start') || '';
        const endValue = this.getAttribute('data-end') || '';
        const start = startValue === '' ? null : Number(startValue) * 1000;
        const end = endValue === '' ? null : Number(endValue) * 1000;
        const now = Date.now();
        const valid = (start === null || Number.isFinite(start)) &&
          (end === null || Number.isFinite(end)) &&
          (start === null || end === null || end > start);
        const visible = valid && (start === null || now >= start) &&
          (end === null || now < end);
        this.hidden = !visible;
        const gallery = this.closest('media-gallery');
        if (gallery) gallery.classList.toggle('media-gallery--has-promo-badge', visible);
        if (!valid || (start === null && end === null)) return;
        const future = [start, end].filter(value => value !== null && value > now);
        const delay = future.length ? Math.min(60000, Math.min(...future) - now) : 60000;
        this.timer = setTimeout(() => this.updateVisibility(), Math.max(50, delay));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    // Shared registration: safe when both gallery snippets are loaded.
  if (!customElements.get('scheduled-promo-badge')) {
    customElements.define('scheduled-promo-badge', class extends HTMLElement {
      static get observedAttributes() { return ['data-start', 'data-end']; }

      connectedCallback() {
        this.refresh = this.refresh || this.updateVisibility.bind(this);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
        this.updateVisibility();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      attributeChangedCallback() {
        if (this.isConnected) this.updateVisibility();
      }

      updateVisibility() {
        clearTimeout(this.timer);
        const startValue = this.getAttribute('data-start') || '';
        const endValue = this.getAttribute('data-end') || '';
        const start = startValue === '' ? null : Number(startValue) * 1000;
        const end = endValue === '' ? null : Number(endValue) * 1000;
        const now = Date.now();
        const valid = (start === null || Number.isFinite(start)) &&
          (end === null || Number.isFinite(end)) &&
          (start === null || end === null || end > start);
        const visible = valid && (start === null || now >= start) &&
          (end === null || now < end);
        this.hidden = !visible;
        const gallery = this.closest('media-gallery');
        if (gallery) gallery.classList.toggle('media-gallery--has-promo-badge', visible);
        if (!valid || (start === null && end === null)) return;
        const future = [start, end].filter(value => value !== null && value > now);
        const delay = future.length ? Math.min(60000, Math.min(...future) - now) : 60000;
        this.timer = setTimeout(() => this.updateVisibility(), Math.max(50, delay));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
